<template>
  <div :class="$style.slide">
    <div :class="$style.content">
      <img :class="$style.image" v-if="slide.image" :src="slide.image.url" alt="">
      <p :class="$style.text" v-html="$options.filters.translate(slide.text)"></p>
    </div>
    <slot></slot>
  </div>
</template>

<script type="text/babel">
export default {
  methods: {
    next() {
      this.$emit('next');
    },
    prev() {
      this.$emit('prev');
    },
  },
  props: {
    slide: {
      required: true,
    },
  },
  created() {
    const { title, id } = this.slide;
    this.$route.meta.title = title;
    this.$route.meta.options = { id: (id + 1) };

    this.$router.replace({ query: { temp: Date.now() } });
  },
};
</script>

<style lang="scss" module>
  .slide {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-auto-rows: 1fr min-content min-content;
    width: 100%;
    height: 100%;
    color: #333;
    padding: 2em;
    box-sizing: border-box;
  }
  .title {
    color: var(--primary);
    border: solid .15em;
    display: inline-block;
    position: relative;
    align-self: flex-start;
    padding: .5em;
    margin: 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    width: 100%;
  }
  .text {
    font-size: var(--text-size);
  }
  .image {
    height: 15em;
    max-width: 100%;
    // margin-top: -2em;
    margin-bottom: 1em;
  }
</style>
